<script>
    import CategoriesBar from "./Scaffold.svelte";
    import Card from "./Card.svelte";
    import { removeProduct, updateProduct, query, categoryValue, initialLoaded, updateDeliveryDiscount, deliveryDiscountPercentage } from "./stores/products";
    import { onMount } from 'svelte';
    import { faCheckCircle, faPhone, faPlus } from '@fortawesome/free-solid-svg-icons';
    import Fa from 'svelte-fa';
    import { fly } from 'svelte/transition';
    import { quadIn, quadOut } from 'svelte/easing';
    import { items, addItem as addItemtoCart } from './stores/cart.js'; // import your store and addItem function
    import Fab from "./Fab.svelte";
    import { sidebarStore } from "./sideBar.js";
    import CategoriesComponent from './CategoriesComponent.svelte';
    import { currentPage, currentPageResponse, products, changePage } from './stores/products.js';
    import { Product } from "./proto/products_pb";
    import { navigate } from "svelte-routing";
    import Pagination from '@fouita/pagination'
    import { tick } from 'svelte';
    import { idToken, isAdmin } from "./stores/id_token";
    import { emails } from "./constants";
  import { searchStore } from "./stores/state";
  import { config, formatTime, formatWorkingDays, isHoliday, isHolidayOrOutsideWorkingHours, isOutsideWorkingHours } from "./config";
  import Banner from "./Banner.svelte";
  import { AnalyticsService } from "./services/analytics";
  const analyticsService = new AnalyticsService();
    let current = 1;
    // $: num_items = $currentPageResponse.getTotalelements();
    let num_items = 0;
    let showPagination = false;
    currentPageResponse.subscribe(async (value) => {
        console.log('value updated in special code', value.getTotalelements());
        if (num_items != value.getTotalelements()) {
                num_items = value.getTotalelements();
                showPagination = false;
                await tick();
                showPagination = true;
        }
    });

    $: console.log("page response: ", $currentPageResponse.getTotalelements());
    let per_page = 20;


    onMount(() => {
      setTimeout(() => {
        showPagination = true;
      }, 100); // delay of 100ms
      
      // call this every time we enter a shopping cart to check if we have a discount.
      updateDeliveryDiscount();
    });


    // Function to reset scroll position
    function resetScrollPosition() {
        window.scrollTo(0, 0);
    }

    // Execute side effect on current changed
    $: {
        const newPage = $currentPage.clone();
        newPage.setPage(current);
        console.log('current page', current);
        $currentPage = (newPage);
        analyticsService.trackProductPageChange(current);

        // Reset scroll position when page changes
        resetScrollPosition();
    }


    /**
	 * @function
	 * @name addItem
	 * @param {Product} data - Array of data items.
	 */
    function addItem(data) {
        showMessage = true;
        addItemtoCart(data);

        setTimeout(() => {
        showMessage = false;
        }, 3000);  // Snackbar will disappear after 3 seconds
    }

    let showMessage = false;


    console.log($products);

    function openCreateProductsPage() {
        navigate('/create-product');
    }

    // Filter products to exclude "Неналични" category for non-admin users
    $: visibleProducts = $products.filter(product => {
        const isUnavailable = product.getCategory() === "Неналични";
        return !isUnavailable || $isAdmin;
    });

    const workingHoursStart = formatTime(config.workingHours.start);
    const workingHoursEnd = formatTime(config.workingHours.end);
</script>

{#if isHoliday()}
    <Banner message={`Уебсайтът е в празничен период от ${config.holidayFrom.toLocaleDateString()} до ${config.holidayTo.toLocaleDateString()}.`} style="z-index: 15;" />
{:else if isOutsideWorkingHours()}
    {#if isOutsideWorkingHours()}
        <Banner message={`Уебсайтът е извън работно време.  Работно време е от ${workingHoursStart} до ${workingHoursEnd}, ${formatWorkingDays(config.workingDays)}.`} style="z-index: 15;" />
    {/if}
{:else if $deliveryDiscountPercentage > 0}
  <Banner message={`Вие сте от първите 100 клиенти - БЕЗПЛАТНА ДОСТАВКА`} customClass={`!z-10`} sticky={``}/>
{/if}

{#if visibleProducts.length === 0 && initialLoaded}
  <div class="flex flex-col items-center justify-center h-screen">
    <h1 class="text-2xl font-bold text-gray-700">Няма налични продукти</h1>
    {#if query && categoryValue}
      <p class="text-gray-500">Няма намерени продукти за зададените категория и търсене.</p>
      <button class="button w-64 mt-1" on:click={() => { searchStore.updateQuery(''); searchStore.updateCategory(''); }}>Изчисти филтрите</button>
    {:else if query}
      <p class="text-gray-500">Няма намерени продукти за зададеното търсене.</p>
      <button class="button w-64 mt-1" on:click={() => { searchStore.updateQuery(''); }}>Изчисти филтрите</button>
    {:else if categoryValue}
      <p class="text-gray-500">Няма намерени продукти за зададената категория.</p>
      <button class="button w-64 mt-1" on:click={() => { searchStore.updateCategory(''); }}>Изчисти филтрите</button>
    {:else}
      <p class="text-gray-500">Моля, опитайте отново по-късно.</p>
    {/if}
  </div>
{:else}
  <div class="max-w-full m-4 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-4">
    <!-- loop around the visibleProducts and put cards -->
    {#each visibleProducts as item (item.getId())}
        <Card {item} onAddToCart={() => addItem(item)} canEdit={$isAdmin} updateProduct={updateProduct} deleteProduct={removeProduct} />
    {/each}
    <div class="h-10"></div>
  </div>
  <!-- Pagination controls -->
  <div class="fixed bottom-0 translate-x-[-50%] left-[50%]">
      {#if showPagination}
          <Pagination rounded bind:current={current} {num_items} {per_page} />
      {/if}
  </div>
{/if}

{#if $isAdmin}
    <Fab onClick={openCreateProductsPage}>
        Създай
        <Fa slot="icon" icon={faPlus} />
    </Fab>
{:else}
    <Fab href='tel:0879399088'>
        <Fa icon={faPhone} class="text-xl" slot="icon" />
        Обаждане
    </Fab>
{/if}


{#if showMessage}
  <div class="fixed inset-x-0 bottom-0 flex items-center justify-center mb-4 px-4 sm:px-0" in:fly={{x: 1000, duration: 260, easing: quadOut}} out:fly={{x:-1000, duration: 200, eaasing: quadIn}}>
    <div class="bg-green-200 text-green-900 p-3 rounded flex items-center space-x-3 w-full max-w-lg">
      <Fa icon={faCheckCircle} class="text-xl"/>
      <span>Добавено в количката!</span>
    </div>
  </div>
{/if}

